import de from "./i18n/de.js";
import en from "./i18n/en.json";
import zh from "./i18n/zh.json";

const i18n = {
	de,
	en,
	zh
};

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n.js